<template>
	<v-app>
		<NavBar />

		<v-main class="ma-4 d-flex flex-column align-start">
			<h1>Flights Export</h1>
			<Datepicker
				class="ma-1 d-inline-flex"
				v-model="fromDate"
				:enable-time-picker="false"
			></Datepicker>
			<Datepicker
				class="ma-1 d-inline-flex"
				v-model="toDate"
				:enable-time-picker="false"
			></Datepicker>
			<v-btn
				:disabled="loading"
				color="primary"
				class="ma-1 d-inline-flex"
				@click="generate()"
			>
				Export
			</v-btn>
			<v-progress-circular
				v-if="loading"
				indeterminate
				color="primary"
			></v-progress-circular>
			<v-container
				fluid
				class="fill-height d-inline-flex"
				id="adobe-dc-view"
				ref="pdfViewerContainer"
			></v-container>
		</v-main>
	</v-app>
</template>

<script>
import NavBar from "@/components/NavBar";
import Datepicker from "@vuepic/vue-datepicker";
import axios from "axios";
import { mapState } from "vuex";

let pdfViewer = null;
export default {
	data() {
		return {
			fromDate: new Date(),
			toDate: new Date(),
			loading: false,
			viewerOptions: null,
		};
	},
	components: {
		NavBar,
		Datepicker,
	},
	computed: {
		...mapState({
			token: "token",
		}),
	},
	methods: {
		generate() {
			this.loading = true;

			axios
				.post(
					process.env.VUE_APP_BACKEND_URL + "/flight/export",
					{
						fromDate: this.fromDate,
						toDate: this.toDate,
					},
					{
						headers: {
							Authorization: "bearer " + this.token,
						},
					}
				)
				.then((res) => {
					this.loading = false;
					console.log(res);
					this.showPdf(res.data);
				});
		},
		showPdf(id) {
			this.viewerOptions = {
				showDownloadPDF: false,
				showZoomControl: true,
				showAnnotationTools: false,
			};

			pdfViewer = new AdobeDC.View({
				clientId: process.env.VUE_APP_ACROBAT_CLIENTID, // Hier deine Adobe API-Client-ID einfügen
			});
			pdfViewer.previewFile(
				{
					content: {
						location: {
							url: process.env.VUE_APP_BACKEND_URL + "/flight/export/" + id,
						},
					},
					metaData: { fileName: "FlightExport.pdf" },
				},
				this.viewerOptions
			);
		},
	},
};
</script>
